import {withFormSecurityCheck} from "@shared/security/SecurityCheck"
import SecurityCheckForm from "@shared/security/SecurityCheckForm"

const CheckedForm = withFormSecurityCheck(SecurityCheckForm)
export default CheckedForm
